import type React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useQueryItemsForBoards } from "@/components/CloneView/hooks/hooks";
import { setSearchBoards } from "@/components/QuickSearch/state/mondaySearchReducer";

const DataPreloader: React.FC = () => {
  const { loading, boards, hasMore, loadNextPage } = useQueryItemsForBoards();
  const dispatch = useDispatch();

  useEffect(() => {
    if (hasMore && !loading) {
      loadNextPage();
    }
  }, [hasMore, loadNextPage, loading]);

  useEffect(() => {
    dispatch(
      setSearchBoards({
        data: boards,
        isLoading: hasMore,
      })
    );
  }, [boards, dispatch]);

  return null;
};

export default DataPreloader;
